/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{isSupported as o}from"../../geometry/support/geodesicUtils.js";import{isGeographic as t,isWebMercator as e}from"../../geometry/support/spatialReferenceUtils.js";function r(r){return t(r)&&o(r)||e(r)}function p(r,p,i,...n){return t(r)&&o(r)?p.apply(void 0,n):e(r)?i.apply(void 0,n):null}const i=1e5;export{i as geodesicDistanceThreshold,p as geodesicMeasure,r as supportsGeodesicMeasurement};
